import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import { Accordion, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { Node } from '@uncinc/react-drupal-core';

import c from 'classnames';
import useClasses from '../../../hooks/useClasses';
import { ImmutableParagraphFaqEntity } from '..';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableParagraphFaqEntity;
}

const ParagraphFaq: React.FC<Props> = ({
  entity, className,
}) => {
  const { buildClass, joinClasses } = useClasses('ParagraphFaq');
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const body = entity.getIn(['field_text', 0, 'processed'], '');

  const gridClasses = c('col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12 offset-sm-0 col-12');

  return (
    <article className={joinClasses(className, buildClass(), className)}>
      <div className="row">
        <div className={gridClasses}>
          {title && <h2 className={buildClass('title')}>{title}</h2>}
          {body && (
            <WysiwygField
              property="schema:text"
              className={joinClasses(buildClass('text'))}
              html={body}
            />
          )}
          <Accordion className={buildClass('accordion')}>
            {entity.get('field_questions', Immutable.List()).map((question) => {
              const id = question.get('target_id');
              const language = question.getIn(['entity', 'langcode', 0, 'value']);
              return (
                <div key={`question:${id}:${language}`}>
                  <Node id={question.get('target_id')} entity={question.get('entity')} />
                </div>
              );
            })}
          </Accordion>
        </div>
      </div>
    </article>
  );
};

export default ParagraphFaq;
